/* JT's Shock Oil — theme behaviour */
(function () {
  'use strict';

  /* ---- mobile nav ---- */
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---- product variant picker ---- */
  var picker = document.querySelector('[data-variant-picker]');
  if (picker) {
    var idInput = document.querySelector('[data-variant-input]');
    var priceEl = document.querySelector('[data-variant-price]');
    var skuEl = document.querySelector('[data-variant-sku]');
    var submitBtn = document.querySelector('[data-add-button]');
    var variants = [];

    try {
      variants = JSON.parse(document.querySelector('[data-variant-json]').textContent);
    } catch (e) {
      variants = [];
    }

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function select(id) {
      var variant = null;
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) { variant = variants[i]; break; }
      }
      if (!variant) return;

      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (skuEl) skuEl.textContent = variant.sku || '—';

      /* show the bottle that matches the chosen viscosity */
      var heroImg = document.querySelector('[data-product-main-image]');
      if (heroImg && variant.image) {
        heroImg.src = variant.image;
        heroImg.alt = variant.imageAlt || variant.title;
      }

      picker.querySelectorAll('.variant-pill').forEach(function (pill) {
        pill.classList.toggle('is-selected', String(pill.dataset.variantId) === String(id));
      });

      if (submitBtn) {
        /* the cart being at its per-order limit outranks variant availability —
           never re-enable the button just because a different viscosity is in stock */
        if (submitBtn.dataset.cartFull === 'true') {
          submitBtn.setAttribute('disabled', 'disabled');
          submitBtn.textContent = submitBtn.dataset.labelLimit || 'Cart limit reached';
        } else if (variant.available) {
          submitBtn.removeAttribute('disabled');
          submitBtn.textContent = submitBtn.dataset.labelAdd || 'Add to cart';
        } else {
          submitBtn.setAttribute('disabled', 'disabled');
          submitBtn.textContent = submitBtn.dataset.labelSoldOut || 'Sold out';
        }
      }

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    picker.addEventListener('click', function (event) {
      var pill = event.target.closest('.variant-pill');
      if (pill) select(pill.dataset.variantId);
    });

    picker.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var pill = event.target.closest('.variant-pill');
      if (pill) { event.preventDefault(); select(pill.dataset.variantId); }
    });
  }

  /* ---- product thumbnails ---- */
  var mainImage = document.querySelector('[data-product-main-image]');
  if (mainImage) {
    document.querySelectorAll('[data-product-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        mainImage.src = thumb.dataset.fullSrc || thumb.src;
      });
    });
  }

  /* ---- chip filters (shop viscosities, tutorial categories) ---- */
  document.querySelectorAll('[data-filter-row]').forEach(function (filterRow) {
    /* each row says what it filters; the shop grid is the default */
    var target = filterRow.dataset.filterTarget || 'shop-card';
    var selector = '[data-' + target + ']';

    filterRow.addEventListener('click', function (event) {
      var chip = event.target.closest('.filter-chip');
      if (!chip) return;

      filterRow.querySelectorAll('.filter-chip').forEach(function (c) {
        c.classList.toggle('is-active', c === chip);
      });

      var group = chip.dataset.filter;
      var shown = 0;
      document.querySelectorAll(selector).forEach(function (card) {
        var visible = (group === 'all' || card.dataset.group === group);
        card.style.display = visible ? '' : 'none';
        if (visible) shown++;
      });

      /* tell the visitor the category is empty rather than showing blank space */
      var emptyMsg = document.querySelector('[data-' + target.split('-')[0] + '-empty]');
      if (emptyMsg) emptyMsg.hidden = shown > 0;
    });
  });

  /* ---- contact form: preselect subject from ?subject= ---- */
  var subjectSelect = document.querySelector('[data-subject-select]');
  if (subjectSelect) {
    var wanted = new URLSearchParams(window.location.search).get('subject');
    if (wanted) {
      var target = wanted.toLowerCase();
      [].forEach.call(subjectSelect.options, function (opt) {
        if (opt.value.toLowerCase().indexOf(target) !== -1) {
          subjectSelect.value = opt.value;
        }
      });
    }
  }

  /* ---- tutorial guide reader ---- */
  var guideTriggers = [].slice.call(document.querySelectorAll('[data-guide-open]'));
  if (guideTriggers.length) {
    var reader = null, readerLast = null;

    function readerBuild() {
      reader = document.createElement('div');
      reader.className = 'reader';
      reader.setAttribute('role', 'dialog');
      reader.setAttribute('aria-modal', 'true');
      reader.setAttribute('aria-label', 'Guide');
      reader.innerHTML =
        '<div class="reader__panel" role="document">' +
          '<button type="button" class="reader__close" aria-label="Close guide">' +
            '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
            'stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
          '</button>' +
          '<div class="reader__scroll">' +
            '<p class="reader__cat"></p>' +
            '<h2 class="reader__title"></h2>' +
            '<p class="reader__summary"></p>' +
            '<img class="reader__img" alt="" hidden>' +
            '<div class="reader__copy rte"></div>' +
          '</div>' +
        '</div>';
      document.body.appendChild(reader);
      reader.querySelector('.reader__close').addEventListener('click', readerClose);
      reader.addEventListener('click', function (e) { if (e.target === reader) readerClose(); });
    }

    function readerOpen(card) {
      var src = card.querySelector('[data-guide-full]');
      if (!src) return;
      if (!reader) readerBuild();

      var pick = function (sel) {
        var el = src.querySelector(sel);
        return el ? el.innerHTML : '';
      };
      var thumb = (src.querySelector('[data-guide-thumb]') || {}).textContent || '';

      reader.querySelector('.reader__cat').textContent =
        (src.querySelector('[data-guide-cat]') || {}).textContent || '';
      reader.querySelector('.reader__title').textContent =
        (src.querySelector('[data-guide-title]') || {}).textContent || '';
      var summary = (src.querySelector('[data-guide-summary]') || {}).textContent || '';
      var sumEl = reader.querySelector('.reader__summary');
      sumEl.textContent = summary;
      sumEl.hidden = !summary.trim();
      reader.querySelector('.reader__copy').innerHTML = pick('[data-guide-copy]');

      var img = reader.querySelector('.reader__img');
      if (thumb.trim()) {
        img.src = thumb.trim();
        img.alt = (src.querySelector('[data-guide-alt]') || {}).textContent || '';
        img.hidden = false;
      } else {
        img.hidden = true;
        img.removeAttribute('src');
      }

      readerLast = document.activeElement;
      reader.classList.add('is-open');
      document.body.classList.add('lightbox-open');
      reader.querySelector('.reader__scroll').scrollTop = 0;
      reader.querySelector('.reader__close').focus();
      document.addEventListener('keydown', readerKey);
    }

    function readerClose() {
      reader.classList.remove('is-open');
      document.body.classList.remove('lightbox-open');
      document.removeEventListener('keydown', readerKey);
      if (readerLast && readerLast.focus) readerLast.focus();
    }

    function readerKey(e) {
      if (e.key === 'Escape') { readerClose(); return; }
      if (e.key !== 'Tab') return;
      /* keep focus inside the reader while it's open */
      var f = reader.querySelectorAll('button, a[href], [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    guideTriggers.forEach(function (card) {
      card.addEventListener('click', function () { readerOpen(card); });
    });
  }

  /* ---- gallery lightbox ---- */
  var zoomTriggers = [].slice.call(document.querySelectorAll('[data-lightbox]'));
  if (zoomTriggers.length) {
    var lb, lbImg, lbCap, lbCount, lbPrev, lbNext, lbClose;
    var current = 0, lastFocused = null;

    function icon(d) {
      return '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
             'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + '</svg>';
    }

    function build() {
      lb = document.createElement('div');
      lb.className = 'lightbox';
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-modal', 'true');
      lb.setAttribute('aria-label', 'Image viewer');
      lb.innerHTML =
        '<button type="button" class="lightbox__btn lightbox__close" aria-label="Close">' +
          icon('<path d="M18 6L6 18M6 6l12 12"/>') + '</button>' +
        '<button type="button" class="lightbox__btn lightbox__prev" aria-label="Previous image">' +
          icon('<path d="M15 18l-6-6 6-6"/>') + '</button>' +
        '<button type="button" class="lightbox__btn lightbox__next" aria-label="Next image">' +
          icon('<path d="M9 18l6-6-6-6"/>') + '</button>' +
        '<div class="lightbox__stage"><img class="lightbox__img" alt=""></div>' +
        '<p class="lightbox__caption"><span class="lightbox__count"></span><span class="lightbox__text"></span></p>';
      document.body.appendChild(lb);

      lbImg   = lb.querySelector('.lightbox__img');
      lbCap   = lb.querySelector('.lightbox__text');
      lbCount = lb.querySelector('.lightbox__count');
      lbClose = lb.querySelector('.lightbox__close');
      lbPrev  = lb.querySelector('.lightbox__prev');
      lbNext  = lb.querySelector('.lightbox__next');

      lbClose.addEventListener('click', close);
      lbPrev.addEventListener('click', function () { show(current - 1); });
      lbNext.addEventListener('click', function () { show(current + 1); });
      lb.addEventListener('click', function (e) { if (e.target === lb || e.target.className === 'lightbox__stage') close(); });

      var single = zoomTriggers.length < 2;
      lbPrev.hidden = single;
      lbNext.hidden = single;
    }

    function show(i) {
      var n = zoomTriggers.length;
      current = (i + n) % n;
      var t = zoomTriggers[current];
      lbImg.src = t.dataset.full;
      lbImg.alt = t.getAttribute('aria-label').replace(/^Enlarge image:\s*/, '');
      lbCap.textContent = t.dataset.caption || '';
      lbCount.textContent = n > 1 ? (current + 1) + ' of ' + n : '';
    }

    function open(i) {
      if (!lb) build();
      lastFocused = document.activeElement;
      show(i);
      lb.classList.add('is-open');
      document.body.classList.add('lightbox-open');
      lbClose.focus();
      document.addEventListener('keydown', onKey);
    }

    function close() {
      lb.classList.remove('is-open');
      document.body.classList.remove('lightbox-open');
      document.removeEventListener('keydown', onKey);
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    function onKey(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'ArrowLeft')  { show(current - 1); return; }
      if (e.key === 'ArrowRight') { show(current + 1); return; }
      if (e.key !== 'Tab') return;
      // keep focus inside the dialog
      var focusable = [].slice.call(lb.querySelectorAll('button')).filter(function (b) { return !b.hidden; });
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    zoomTriggers.forEach(function (t, i) {
      t.addEventListener('click', function () { open(i); });
    });
  }
})();
